import { faCog, faSignOut, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from 'react-oidc-context';

import { Avatar } from '@/common/components/avatar';
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu
} from '@/common/components/dropdown';
import { NavbarItem } from '@/common/components/navbar';
import { SidebarItem } from '@/common/components/sidebar/sidebar';
import { ChevronRightIcon } from '@/icons/fa/regular';
import { useLogout } from '@/shared/hooks/use-logout';
import { getGravatarUrl } from '@/shared/users';

/**
 * A user menu component for use in the sidebar.
 */
export function SidebarUserMenu() {
  const { user } = useAuth();

  return (
    <Dropdown>
      <DropdownButton as={SidebarItem}>
        <Avatar src={getGravatarUrl(user?.profile.email)} alt="" />
        <span className="flex flex-col min-w-0 text-left">
          <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">{user?.profile.name}</span>
          <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">
            {user?.profile.email}
          </span>
        </span>
        <ChevronRightIcon />
      </DropdownButton>
      <UserMenu />
    </Dropdown>
  );
}

/**
 * A user menu component for use in the top navbar.
 */
export function NavbarUserMenu() {
  const { user } = useAuth();

  return (
    <Dropdown>
      <DropdownButton as={NavbarItem}>
        <Avatar src={getGravatarUrl(user?.profile.email)} square />
      </DropdownButton>
      <UserMenu />
    </Dropdown>
  );
}

/**
 * A component for user-related actions such as viewing profile, settings, or signing out.
 */
function UserMenu() {
  const logout = useLogout();

  return (
    <DropdownMenu className="min-w-64" anchor="top start">
      <DropdownItem href="/my-profile">
        <FontAwesomeIcon icon={faUser} data-slot="icon" />
        <DropdownLabel>My profile</DropdownLabel>
      </DropdownItem>
      <DropdownItem href="/my-settings">
        <FontAwesomeIcon icon={faCog} data-slot="icon" />
        <DropdownLabel>My settings</DropdownLabel>
      </DropdownItem>
      <DropdownDivider />
      <DropdownItem onClick={logout}>
        <FontAwesomeIcon icon={faSignOut} data-slot="icon" />
        <DropdownLabel>Sign out</DropdownLabel>
      </DropdownItem>
    </DropdownMenu>
  );
}
